module.exports = require('./helpers/bundle-url').getBundleURL('lKZFx') + "logo-dark.ba5147f0.svg";